var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighHeel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10374 20.4528H5.65994V12.4785C5.65994 11.9055 5.88116 11.3553 6.27608 10.9462C6.36502 10.854 6.51111 10.854 6.60004 10.9462L6.69329 11.0428C7.03775 11.3997 7.30173 11.8284 7.46696 12.2991L9.81381 18.9861C10.1371 19.9072 10.8732 20.6359 11.8233 20.7939C14.8658 21.3001 18.1035 20.7862 20.2894 20.1961C21.3347 19.914 22 18.921 22 17.8223V16.9028C22 16.1569 21.4759 15.5173 20.7538 15.382L16.7819 14.6378C15.941 14.4802 15.0744 14.5409 14.2627 14.8144C12.9968 15.2409 11.6362 14.4508 11.2036 13.1692C10.2395 10.3127 8.37054 6.30697 5.36756 3.20097C5.10282 2.92714 4.6698 2.936 4.40529 3.21006L3.32565 4.3287C1.76945 5.61863 1.89914 8.09098 2.1585 9.16592C3.7147 10.7783 4.10374 16.8249 4.10374 20.4528Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighHeel2);
export default __webpack_public_path__ + "static/media/high-heel-2.91881d5cc16ef1224d73215aa7ad85f7.svg";
export { ForwardRef as ReactComponent };